
import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import IntroductionBanner from '../../../assets/about-us/about-introduction-banner.jpg'
import { useTranslation } from 'react-i18next'

export const SMAppMotorLoanIntroduction: React.FC = () => {
    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
                paddingBottom: '60px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >

            <Box>
                <Image src={IntroductionBanner} alt='' style={{ objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontSize={24} fontWeight={700} color={'#141F39'} paddingTop={'20px'}>
                    {t('t112')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'30px'}>
                    {t('t113')}
                </Typography>
                
                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'30px'}>
                    {t('t114')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'30px'}>
                    {t('t115')}
                </Typography>

            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppMotorLoanIntroduction
